import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'personName',
  pure: false,
})
export class PersonNamePipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    if (!value)
      return '';
    
    return  `${value.firstName} ${value.lastName}`;
  }
}
